import { Input, Label, Row, Col } from 'reactstrap';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';
import 'react-datepicker/dist/react-datepicker.css';
import ComponentCard from '../../../layouts/containers/ComponentCard';

const disableFutureDates = (date) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date < today;
};

const DatosEscolaresForm = ({
  formik,
  yearsApi,
  academicFormation,
  formationCenter,
  studiesList,
  studiesList2,
  lastStudiesList,
  sitLaboralList,
  empresaId,
  idCedesca,
  idCntec,
  rowRef2,
  handleFechaTitulos,
}) => {
  return (
    <ComponentCard title="Datos escolares" hasButton>
      <Row>
        <Col md="2">
          <Label htmlFor="idioma">
            <small ref={rowRef2}>
              Idioma <span className="text-danger">*</span>
            </small>
          </Label>
          <Input
            id="idioma"
            name="idioma"
            type="select"
            onChange={formik.handleChange}
            value={formik.values.idioma}
            className={formik.errors.idioma ? 'border border-danger error rounded ' : ''}
          >
            <option key="0-idioma" value=""></option>
            <option key="1-idioma" value="Español">
              Español
            </option>
            <option key="2-idioma" value="Catalán">
              Catalán
            </option>
          </Input>
          {formik.errors.idioma ? (
            <div className="text-danger tiny">{formik.errors.idioma}</div>
          ) : null}
        </Col>
        <Col md="2">
          <Label htmlFor="idalu">
            <small>IDALU</small>
          </Label>
          <Input
            id="idalu"
            name="idalu"
            type="text"
            onChange={formik.handleChange}
            value={formik.values.idalu}
          />
        </Col>
        <Col md="3">
          <Label htmlFor="sede">
            <small>
              Sede examen <span className="text-danger">*</span>
            </small>
          </Label>
          <Input
            id="sede"
            name="sede"
            type="select"
            onChange={formik.handleChange}
            value={formik.values.sede}
            disabled={
              idCedesca > 0 &&
              idCntec > 0 &&
              ((formik.values.centro.toString() !== '9' && empresaId === 'CNTEC') ||
                (formik.values.centro.toString() !== '7' && empresaId === 'CEDESCA'))
            }
            className={formik.errors.sede ? 'border border-danger error rounded' : ''}
          >
            {formationCenter !== ''
              ? (formik.values.centro.toString() === '9' && empresaId === 'CNTEC') ||
                (formik.values.centro.toString() === '7' && empresaId === 'CEDESCA')
                ? formationCenter
                    .filter((entry) => entry.Nombre === 'CAMP JOLIU' || entry.Nombre === 'CEDESCA')
                    .map((option) => (
                      <option key={`${option.Id}-sedeExamen`} value={option.Poblacion}>
                        {option.Poblacion}
                      </option>
                    ))
                : formationCenter.map((option) => (
                    <option key={`${option.Id}-sedeExamen`} value={option.Poblacion}>
                      {option.Poblacion}
                    </option>
                  ))
              : null}
          </Input>
          {formik.errors.sede ? <div className="text-danger tiny">{formik.errors.sede}</div> : null}
        </Col>
        <Col md="3">
          <Label htmlFor="nee">
            <small>NEE</small>
          </Label>
          <Input
            id="nee"
            name="nee"
            type="text"
            onChange={formik.handleChange}
            value={formik.values.nee}
          />
        </Col>
        <Col md="2">
          <Label htmlFor="tsi">
            <small>TSI </small>
          </Label>
          <Input
            id="tsi"
            name="tsi"
            type="text"
            onChange={formik.handleChange}
            value={formik.values.tsi}
          />
        </Col>
      </Row>
      <Row className="mt-2">
        <Col md="2">
          <Label htmlFor="situacionLaboral">
            <small>Situación laboral</small>
          </Label>
          <Input
            id="situacionLaboral"
            name="situacionLaboral"
            type="select"
            onChange={formik.handleChange}
            value={formik.values.situacionLaboral}
          >
            <option key="0-sitLaboral" value=""></option>
            {sitLaboralList.map((item, index) => (
              <option key={`${index}-sitLaboral`} value={item.Valor_cast}>
                {item.Valor_cast}
              </option>
            ))}
          </Input>
        </Col>
        <Col md="3">
          <Label htmlFor="formacionAcademica">
            <small>Curso realizado</small>
          </Label>
          <Input
            id="formacionAcademica"
            name="formacionAcademica"
            type="select"
            onChange={formik.handleChange}
            value={formik.values.formacionAcademica}
          >
            {academicFormation !== ''
              ? academicFormation.map((option) => (
                  <option key={`${option.id}-formacionAcademica`} value={option.Valor}>
                    {option.Valor}
                  </option>
                ))
              : ''}
          </Input>
        </Col>
        <Col md="3">
          <Label htmlFor="antiguoCentro">
            <small>Centro de procedencia</small>
          </Label>
          <Input
            id="antiguoCentro"
            name="antiguoCentro"
            type="text"
            onChange={formik.handleChange}
            value={formik.values.antiguoCentro}
          />
        </Col>
        <Col md="4">
          <Label htmlFor="antiguosEstudios">
            <small>Estudios de procedencia</small>
          </Label>
          <Input
            id="antiguosEstudios"
            name="antiguosEstudios"
            type="select"
            onChange={formik.handleChange}
            value={formik.values.antiguosEstudios}
          >
            {studiesList !== ''
              ? studiesList.map((option) => (
                  <option key={`${option.Id_Estudio}-estudiosProcedencia`} value={option.Estudio}>
                    {option.Estudio_cast}
                  </option>
                ))
              : ''}
          </Input>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col md="2">
          <Label htmlFor="notaMedia">
            <small>Nota media</small>
          </Label>
          <Input
            id="notaMedia"
            name="notaMedia"
            type="text"
            onChange={formik.handleChange}
            value={formik.values.notaMedia}
            className={formik.errors.notaMedia ? 'border border-danger error' : ''}
          />
          {formik.errors.notaMedia ? (
            <div className="text-danger tiny">{formik.errors.notaMedia}</div>
          ) : null}
        </Col>
        <Col md="3">
          <Label htmlFor="fechaUltimoCurso">
            <small>Fecha último curso</small>
          </Label>
          <Input
            id="fechaUltimoCurso"
            name="fechaUltimoCurso"
            type="select"
            onChange={formik.handleChange}
            value={formik.values.fechaUltimoCurso}
          >
            {yearsApi !== ''
              ? yearsApi.map((option) => (
                  <option key={`${option.Id}-fechaUltimoCurso`} value={option.Valor}>
                    {option.Valor}
                  </option>
                ))
              : ''}
          </Input>
        </Col>
        <Col md="3">
          <Label htmlFor="fechaTitulo">
            <small>Fecha obtención del título</small>
          </Label>
          <DatePicker
            selected={formik.values.fechaTitulo}
            onChange={handleFechaTitulos}
            dateFormat="dd/MM/yyyy"
            locale="es"
            maxDate={new Date()}
            filterDate={disableFutureDates}
            className="form-control"
            wrapperClassName="w-100"
          />
        </Col>
        <Col md="4">
          <Label htmlFor="emailCorp">
            <small>Email corporativo</small>
          </Label>
          <Input
            id="emailCorp"
            name="emailCorp"
            type="text"
            disabled
            onChange={formik.handleChange}
            value={formik.values.emailCorp}
          />
        </Col>
      </Row>
      <Row className="mt-2">
        <Col md="4">
          <Label htmlFor="siguientesEstudios">
            <small>
              Estudios siguientes <span className="text-danger">*</span>
            </small>
          </Label>
          <Input
            id="siguientesEstudios"
            name="siguientesEstudios"
            type="select"
            onChange={formik.handleChange}
            value={formik.values.siguientesEstudios}
            className={formik.errors.siguientesEstudios ? 'border border-danger error' : ''}
          >
            {studiesList2 !== ''
              ? studiesList2.map((option) => (
                  <option key={`${option.Id_Estudio}-estudiosSiguientes`} value={option.Estudio}>
                    {option.Estudio_cast}
                  </option>
                ))
              : ''}
          </Input>
          {formik.errors.siguientesEstudios ? (
            <div className="text-danger tiny">{formik.errors.siguientesEstudios}</div>
          ) : null}
        </Col>
        <Col md="3">
          <Label htmlFor="formaAcceso">
            <small>
              Forma de acceso <span className="text-danger">*</span>
            </small>
          </Label>
          <Input
            id="formaAcceso"
            name="formaAcceso"
            type="select"
            onChange={formik.handleChange}
            value={formik.values.formaAcceso}
            className={formik.errors.formaAcceso ? 'border border-danger error' : ''}
          >
            {lastStudiesList !== ''
              ? lastStudiesList.map((option) => (
                  <option key={`${option.Id}-formaAccesso`} value={option.name}>
                    {option.name_cast}
                  </option>
                ))
              : ''}
          </Input>
          {formik.errors.formaAcceso ? (
            <div className="text-danger tiny">{formik.errors.formaAcceso}</div>
          ) : null}
        </Col>
      </Row>
    </ComponentCard>
  );
};

DatosEscolaresForm.propTypes = {
  formik: PropTypes.object.isRequired,
  yearsApi: PropTypes.array.isRequired,
  academicFormation: PropTypes.array.isRequired,
  formationCenter: PropTypes.array.isRequired,
  studiesList: PropTypes.array.isRequired,
  studiesList2: PropTypes.array.isRequired,
  lastStudiesList: PropTypes.array.isRequired,
  sitLaboralList: PropTypes.array.isRequired,
  empresaId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  idCedesca: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  idCntec: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  rowRef2: PropTypes.object.isRequired,
  handleFechaTitulos: PropTypes.func.isRequired,
};

export default DatosEscolaresForm;
